<template lang="pug">
PrBadge(v-bind="$props")
  slot
</template>

<script>
import styled from "vue-styled-components"

const Props = {
  size: String,
  weight: String,
  arrow: String,
  reverse: Boolean,
  outline: Boolean
}
const PrBadge = styled("span", Props)`
  position: relative;
  display: inline-block;
  padding: 0.25em 0.7em;
  border-radius: 5px;
  line-height: ${props => props.theme.font.lineHeight};
  font-size: ${props => (props.size ? props.theme.font[props.size] : props.theme.font.xsmall)};
  opacity: ${props => (props.muted ? 0.7 : 1)};
  color: ${props => (props.reverse ? props.theme.color.onSurface : props.theme.color.surface)};
  border: ${props => (props.outline ? "1px" : "0px")} solid;
  border-color: ${props => (props.reverse ? props.theme.color.onSurface : props.theme.color.surface)};
  background: ${props => (props.outline ? "transparent" : props.reverse ? props.theme.color.surface : props.theme.color.onSurface)};
  font-weight: ${props => (props.weight ? props.theme.font[props.weight] : props.theme.font.normal)};
  margin: 0;

  b {
    font-weight: ${props => props.theme.font.bold};
  }

  &:after,
  &:before {
    content: "";
    ${props => (!props.arrow ? "display:none !important;" : "display:block;")}
    position: absolute;
    ${props => (props.arrow === "left" ? "right:100%;" : "left:100%;")}
    width: 0;
    height: 0;
    border-style: solid;
    top: 50%;
    transform: translateY(-50%);
  }

  &:after {
    ${props =>
      props.arrow === "left"
        ? "border-color: transparent " +
          //(props.outline ? "transparent" : props.reverse ? props.theme.color.surface : props.theme.color.onSurface) +
          (props.reverse ? props.theme.color.surface : props.theme.color.onSurface) +
          " transparent transparent;"
        : "border-color: transparent transparent transparent " + (props.reverse ? props.theme.color.surface : props.theme.color.onSurface) + ";"}

    border-width: 7px;
  }

  &:before {
    ${props =>
      props.arrow === "left"
        ? "border-color: transparent " + (props.reverse ? props.theme.color.onSurface : props.theme.color.surface) + " transparent transparent;"
        : "border-color: transparent transparent transparent " + (props.reverse ? props.theme.color.onSurface : props.theme.color.surface) + ";"}

    border-width: 9px;
  }
`
export default {
  name: "pr-badge",
  components: {
    PrBadge
  },
  props: {
    ...Props
  }
}
</script>
